import { Box } from '@mui/material';
import { Outlet, useOutlet } from 'react-router-dom';

import { ProjectArtifactsListPage } from './ProjectArtifactsListPage';

/**
 * Right-side content surface for the project page. Renders nested route
 * children when present (phase 4 will mount artifact detail/builder pages
 * here); otherwise falls back to the artifact list as the project's
 * default content.
 */
export const ProjectContentOutlet = () => {
  const outlet = useOutlet();

  return (
    <Box
      data-testid="project-content-outlet"
      sx={{
        height: '100%',
        width: '100%',
        minHeight: 0,
        minWidth: 0,
        overflow: 'auto',
      }}
    >
      {outlet ? <Outlet /> : <ProjectArtifactsListPage />}
    </Box>
  );
};
